import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
//import faker from "faker";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },

    title: {
      display: true,
      text: "Ratings Bar Chart",
    },
  },
};

// export const data = {
//   labels: ["January", "February", "March", "April", "May", "June", "July"],

//   datasets: [
//     {
//       label: "1 Star",
//       data: [10, 15, 10, 15, 15, 5, 15],
//       backgroundColor: "rgba(255, 99, 132, 0.5)",
//     },
//     {
//       label: "5 Stars",
//       data: [10, 15, 5, 10, 15, 25, 15],
//       backgroundColor: "rgba(53, 162, 235, 0.5)",
//     },
//   ],
// };

export default function BarChart({ data }) {
  console.log(data);
  if (data == null) {
    return null;
  }
  return <Bar options={options} data={data} />;
}
